import axios from 'utils/axios';

const VerifyOtpAndResetPasswordService = async (data) => {
    const payload = {
        email: data.email,
        otp: data.otp,
        password: data.password,
        confirmPassword: data.password_confirmation,
    };

    await axios.post('api/auth/reset-password', payload);
};

export default VerifyOtpAndResetPasswordService;
